import axios from 'axios'

const state = {
  newProject: {
    'constructionreport': 1,
    'weatherdata': 1,
    'staffdata': 1,
    'unit_temperature': 1,
    'unit_speed': 1,
    'unit_humidity': 1,
    'show_misc': 1,
    'planparams': [],
    'params': [],
    'dailydocu': 1,
    'constructor': '',
    'weather_zipcode': '',
    'use_weatherdb': 0,
    '_explicitType': 'com\\projectdocu\\ProjectVO',
    'manager': '',
    'staffparams': [],
    'description': '',
    'photodocu': 1,
    'logo1': null,
    'startdate': '2020-12-31 15:08:37',
    'logo2': null,
    'decoimage': null,
    'useAsCustomerLogo1': false,
    'useAsCustomerLogo2': false,
    'company_name_department': '',
    'company_name': null,
    'use_gps': false,
    'shifts': [],
    'lastupdated': null,
    'number': '',
    'name': '',
    'weathercity': '',
    'isAdmin': 0,
    'weatherzipcode': '',
    'weathercitycode': '',
    'weathercountry': '',
    'serviceAreasAC': null,
    'serviceAreasCheckedAC': null,
    'shortname': '',
    'serviceWithCompanyAC': null,
    'active': 0,
    'street': '',
    'zipcode': '',
    'city': '',
    'country': '',
    'status': false,
    'projectid': 0,
    'customer_id': 0,
    'invitationstatus': 0,
    'dailydocutype': 0,
    'rights': 3,
    'photoquality': 2,
    'cr_params': {
      left_footer: true,
      right_footer: true,
      center_footer: true,
      show_creator: true,
      show_constructor: true,
      show_projectnumber: true
    }
  },

  projects: [],
  activeprojects: [],
  archiveprojects: [],

  //these project does not need image
  projectsForDropDown: [],

  favourites: [],
  search: '',
  project: {},
  user: {},
  projectDetails: ''
}

const getters = {
  setProjects: state => state.projects,
  setActiveProjects: state => state.archiveprojects,
  setArchiveProjects: state => state.archiveprojects,
  getFavourites: state => state.favourites
}

const actions = {
  async getProjectsForDropDown ({commit}) {
    let parameters = [];
    await axios.post(process.env.VUE_APP_BASE_AMF_URL+`&token=`+localStorage.sessiontoken,{
          parameters: parameters,
          serviceName: "ProjectdocuService",
          methodName: "getProjects"
        }, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: "application/json"
          }
        })
      .then(response => {
        commit('setProjectsForDropDown', response.data)
      })
      .catch(e => {
        console.log(e)
      })
  },



  async fetchProjectsInfo ({commit}, params) {
    const response = await axios.post(
      'http://localhost/projects/aaa/hrsystem/public/api/user/login',
      params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
    )
    commit('setProjects', response.data.data)
  }
}
const mutations = {
  setAuthUser: (state, payload) => state.user = payload,
  setProjects: (state, projects) => (state.projects = projects),
  setActiveProjects: (state, projects) => (state.activeprojects = projects),
  setArchiveProjects: (state, projects) => (state.archiveprojects = projects),
  setProject: (state, project) => (state.project = project),
  setProjectsForDropDown: (state, projects) => (state.projectsForDropDown = projects),
  setMainProjectDetails: (state, project) => (state.projectDetails = project),
  setfavourites: (state, favourites) => (state.favourites = favourites),
  setSearchStringEmpty: (state) => (state.search = '')
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/projects.js